import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownloadBottom = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "download-bottom" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12.001,
			y1: 3.75,
			x2: 12.001,
			y2: 15.75
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "7.501 11.25 12.001 15.75 16.501 11.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.251,15.75v1.5a3,3,0,0,1-3,3H3.751a3,3,0,0,1-3-3v-1.5"
		})
	]
});
export default SvgDownloadBottom;
